const BASE_URL = "https://s3-us-west-1.amazonaws.com/securspace-files";

export const constructListingImageUrl = (filename: string): string => {
    const baseUrl = `${BASE_URL}/listing-images/`;
    return baseUrl + encodeURIComponent(filename)
}

export const constructGalleryImageUrl = (filename: string): string => {
    const baseUrl = `${BASE_URL}/gallery/`;
    return baseUrl + encodeURIComponent(filename)
}

export const constructQrCode = (filename: string): string => {
    const baseUrl = `${BASE_URL}/bookings-qr-codes/`;
    return baseUrl + encodeURIComponent(filename)
}

export const constructInterchangeGalleryImageUrl = (interchangeId: string, galleryImageFileName: string | null | undefined): string => {
    if (!galleryImageFileName) {
        return '';
    }
    if (galleryImageFileName.startsWith('http://') || galleryImageFileName.startsWith('https://')) {
        return galleryImageFileName;
    }
    return `${BASE_URL}/inventory/${encodeURIComponent(interchangeId)}/${encodeURIComponent(galleryImageFileName)}`;
};